export const getHeightStyle = (level)=>({
        height: `${level.height}%`,
        flex: level.height
    });
